<template>
  <div class="flex flex-col xl:flex-row xl:space-x-4 space-y-2 items-center bg-white border border-gray-100 rounded-lg p-4 hover:shadow-md transition-shadow">
  <img class="w-16 xl:w-20 shrink-0" :src="imageurl" alt="">
    <div class="flex flex-col text-center space-y-1 xl:space-y-1 xl:text-left">
      <h1 class="text-expressgray font-medium text-sm"> {{ title }} </h1>
      <p class="text-gray-900 text-lg font-semibold">{{ label }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "summarycard",
  props:['imageurl', 'title', 'label']
}
</script>

<style scoped>

</style>
